import { Redirect, generatePath, useLocation } from 'react-router-dom'
import ArticleViewWrapper from './ArticleViewWrapper'
import { FOLDER_DOC_PATH } from 'paths'
import { useArticle } from 'hooks/queries/articles/useArticle'
import { useHandbook } from 'components/Handbook2_0/hooks'
import { Spinner } from 'common/Spinner/Spinner'
import Styles from './ArticlePathRedirect.module.scss'

interface ArticlePathRedirectProps {
  articleSlug: string
  articleId: string
}

interface RedirectProps {
  root_handbook_seo_string: string
  docSlug: string
}

const RedirectToHandbook = ({ root_handbook_seo_string, docSlug }: RedirectProps) => {
  const { search, hash, state } = useLocation()
  const pathname = generatePath(FOLDER_DOC_PATH, { folderSlug: root_handbook_seo_string, doc: docSlug })

  return (
    <Redirect
      to={{
        pathname,
        search,
        hash,
        state,
      }}
    />
  )
}

export const ArticlePathRedirect = ({ articleSlug, articleId }: ArticlePathRedirectProps) => {
  const { data: articleData, isLoading } = useArticle(articleId, { retry: false })
  const handbook = useHandbook()

  if (isLoading)
    return (
      <div className={Styles.spinner}>
        <Spinner />
      </div>
    )

  if (articleData?.article) {
    const { slug: docSlug, root_handbook_seo_string } = articleData.article
    const shouldRedirectToHandbook = root_handbook_seo_string && !handbook

    if (shouldRedirectToHandbook) {
      return <RedirectToHandbook root_handbook_seo_string={root_handbook_seo_string} docSlug={docSlug} />
    }
  }

  return <ArticleViewWrapper key={articleId} id={articleId} />
}
